// extracted by mini-css-extract-plugin
export default {"notesForm":"RecordingNotes_notesForm__UBS+l","tagContainer":"RecordingNotes_tagContainer__9tS2e"};